// Generated Zod schemas from Frappe doctype
import { z } from "zod";

export const metadataSchema = z.object({
  farm_visit_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
  field_officer: z.string()
});
export type Metadata = z.infer<typeof metadataSchema>;

export const farmerInfoSchema = z.object({
  farmer: z.string().optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  cluster: z.string().optional()
});
export type FarmerInfo = z.infer<typeof farmerInfoSchema>;

export const farmInfoSchema = z.object({
  latitude: z.string().optional(),
  longitude: z.string().optional(),
  farm_photo: z.instanceof(FileList).optional(),
  no_of_hectares: z.string().optional(),
  package: z.enum(["Maize", "Sorghum/Soya"]),
  crop_condition: z.enum(["Good", "Bad"]),
  remarks: z.string().optional(),
  are_you_satisfied_with_the_quality_of_input_disbursed: z.enum(["Yes", "No"]).optional(),
  what_would_you_like_improvement_on: z.string().optional(),
  amended_from: z.string().optional()
});
export type FarmInfo = z.infer<typeof farmInfoSchema>;

